import request from '@/util/request'


export const departmentsList = (data) => request.post('/api/departmentsList', data);  //部门列表

export const departmentsAdd = (data) => request.post('/api/departmentsAdd', data);  //部门添加

export const departmentsEdit = (data) => request.post('/api/departmentsEdit', data);  //部门编辑

export const departmentsUpdStatus = (data) => request.post('/api/departmentsUpdStatus', data);  //部门更新状态

export const departmentsDetail = (data) => request.post('/api/departmentsDetail', data);  //部门详情
